<template>
  <el-footer height="auto">
    <div class="footer container">
      <div class="middle">
        <div class="middle_url">
          <a target="_blank" href="/about">About Us</a>
        </div>
        <div class="middle_url">
          <a target="_blank" href="/disclaimer">Disclaimer</a>
        </div>
        <div class="middle_url">
          <a target="_blank" href="/legal/1">Privacy Policy</a>
        </div>
        <div class="middle_url">
          <a target="_blank" href="/legal/2">Terms & Conditions</a>
        </div>
        <div class="middle_url">
          <a target="_blank" href="/legal/3">Refund</a>
        </div>

        <div class="icon">
          <a href="/" class="logo"></a>
        </div>
      </div>

      <div class="f-line"></div>

      <div class="copyright">
        <p>Copyright © Mvpstore.net. All Rights Reserved.</p>
      </div>
    </div>
  </el-footer>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      input: '',
      show: false,
      PC_VERSON: '',
      FB_VERSON: '',
      checked: false,
      subscribe_error: '',
      subscribe_step: 0,
      if_valid: false
    }
  },
  props: ['hidedata'],
  methods: {
    toBury (key, f1, f2, f3, f4, f5) {
      this.$axios.get(
        'https://client-click.cn-hongkong.log.aliyuncs.com/logstores/client-logstroe/track',
        {
          params: {
            APIVersion: '0.6.0',
            __topic__: key,
            f1,
            f2,
            f3,
            f4,
            f5,
            log_type: 10001
          }
        }
      )
    }
  },
  created () {
    // this.PC_VERSON = PC_VERSON
    // this.FB_VERSON = FB_VERSON
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-footer {
  position: relative;
  font-size: 14px;
  color: #e7e7e7;
  background-color: #000000;
  // background-image: url('/pc/static/img/hom/bg-b_pro.png');
  // background-position: center bottom;
  // background-repeat: no-repeat;
  .footer {
    position: relative;
    padding: 52px 10px 155px 10px;
    .f-line {
      width: 100%;
      height: 1px;
      background-color: #333333;
      margin: 60px 0px 10px 0px;
    }
    .middle {
      position: relative;
      margin-top: 0px;
      min-height: 54px;
      .middle_url {
        a {
          font-size: 16px;
          margin: 8px 0px;
          display: inline-block;
          box-shadow: 0 1px;
          &:hover {
            color: #ffdf00;
          }
        }
      }
      .icon {
        position: absolute;
        top: 16px;
        right: 0px;
        a {
          margin: 0 20px;
          display: inline-block;
          background-size: 100%;
          background-repeat: no-repeat;
          background-position: center center;
          width: 16px;
          height: 36px;
          // &:hover {
          //   transform: scale(1.1);
          // }
        }
        a {
          webkit-transition: all cubic-bezier(.165,.84,.44,1) .3s;
          -o-transition: all cubic-bezier(.165,.84,.44,1) .3s;
          transition: all cubic-bezier(.165,.84,.44,1) .3s;
          -webkit-transform: scale(1);
          -ms-transform: scale(1);
          transform: scale(1);
        }
        a:hover {
          -webkit-transform: scale(1.1);
          -ms-transform: scale(1.1);
          transform: scale(1.1);
        }
        .logo {
          background-image: url(/pc/static/img/hom/homeLogo.png);
          width: 144px;
          height: 44px;
        }
      }
    }
    .copyright {
      position: relative;
      min-height: 50px;
      p {
        display: inline-block;
        color: #8e8e8e;
        font-size: 14px;
        margin-top: 12px;
      }
    }
  }
}
</style>
